import { EventEmitter } from '@angular/common/src/facade/async';
import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { SurveyService } from './survey.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit, OnDestroy {

  @Input() tripId: number;
  @Output() closeSurvey: EventEmitter < boolean > = new EventEmitter < boolean > ();

  public surveyForm: FormGroup;
  protected showSurvey = true;
  protected data = [];
  private surveyAvility = false;
  surveyShow: boolean = false;
  public subscriptions: Subscription[] = [];

  constructor(private fb: FormBuilder,
    private service: SurveyService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.createForm();
  }

  /**
   * @description
   */
  ngOnInit(): void {
    setTimeout(() => {
      this.loadData();
      this.surveyForm.get('surveydetails').valueChanges.subscribe( val => {
        if (val !== undefined && val !== null) {
          if (val.length > 2) {
            if (val[1].rate == 1) {
              this.surveyShow = false;
              this.questionForm.removeAt(2);
            }
          }
          if (val.length == 2) {
            if (val[1].rate == 2) {
              this.surveyShow = true;
              this.updateQuestions();
            }
          }
        }
      });
    }, 1000);
  }

  loadData() {
    this.service.getSurvey(this.tripId).subscribe(
      data => {
        if (data.length > 0) {
          this.showSurvey = false;
          this.data = data;
        } else {
          this.service
            .getQuestions()
            .subscribe(
              success => {
                for (const questions of success) {
                  const catego = questions.description;
                  const stopSurvey = questions.stopsurvey;
                  let sw = 0;
                  for (const question of questions.questions) {
                    let category = '';
                    const stopsurvey = stopSurvey;
                    if (sw === 0) {
                      category = catego;
                      sw = 1;
                    } else {
                      category = '';
                    }
                    if (questions.categoryquestionid === 5) {
                      let rate;
                      question.questionid === 17 ? rate = 0 : rate = '';
                      this.questionForm.push(this.createSurvey(question.questionid, question.description, category, stopsurvey, rate));
                    }
                  }
                }
              });
        }
      }
    );
  }

  /**
   * @description
   */
  createForm() {
    this.surveyForm = this.fb.group({
      tripid: this.tripId,
      surveydetails: this.fb.array([])
    });
  }
  /**
   * @description
   */
  createSurvey(questionId, question, category, stopsurvey, rate?) {
    return this.fb.group({
      category: category,
      question: question,
      questionid: questionId,
      stopsurvey: stopsurvey,
      rate: [`${rate}`, Validators.required]
    });
  }

  /**
   * @description
   */
  get questionForm(): FormArray {
    return this.surveyForm.get('surveydetails') as FormArray;
  }

  /**
   * @description
   */
  submitForm(survey) {
    let rowEmpty: number = 0;
    survey.tripid = this.tripId;
    const survey2 = JSON.parse(JSON.stringify(survey));
    for (const row of survey2.surveydetails) {
      delete(row.category);
      delete(row.question);
      if (this.surveyShow && row.rate == 'undefined') {
        rowEmpty++;
      }
    }
    if (rowEmpty > 0) {
      this.sweetAlertHelper.createCustomAlert({
        type: 'question',
        text: `There are ${rowEmpty} unanswered questions`,
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      this.subscriptions.push(
        this.service.storeSurvey(survey2).subscribe(
          (data) => {
            this.closeSurvey.emit(true);
            this.showMsj();
            this.loadData();
          },
          (error) => {
            this.sweetAlertHelper.captureException(error);
          }
        )
      );
    }
  }
  updateQuestions() {
    if (this.questionForm.length < 3) {
      this.service
        .getQuestions()
        .subscribe(
          success => {
            for (const questions of success) {
              const catego = questions.description;
              const stopSurvey = questions.stopsurvey;
              let sw = 0;
              for (const question of questions.questions) {
                let category = '';
                const stopsurvey = stopSurvey;
                if (sw === 0) {
                  category = catego;
                  sw = 1;
                } else {
                  category = '';
                }
                if (questions.categoryquestionid !== 5) {
                  this.questionForm.push(this.createSurvey(question.questionid, question.description, category, stopsurvey));
                }
              }
            }
          });
    }
  }

  showMsj() {
    this.sweetAlertHelper.createCustomAlert({
      position: 'top-end',
      type: 'success',
      text: 'Completed Survey',
      showConfirmButton: false,
      timer: 1500
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/survey/survey.component.ts